import { inject } from '@angular/core';
import { CanActivateFn, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Router } from '@angular/router';

export const authGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const platformId = inject(PLATFORM_ID);
  const router = inject(Router);

  if (!isPlatformBrowser(platformId)) {
    return true;
  }

  const token = route.queryParamMap.get('token');
  const id = route.queryParamMap.get('id');
  const module = route.queryParamMap.get('module');

  if (token) {
    localStorage.setItem('userToken', token);
    if (id) localStorage.setItem('userId', id);
    if (module) localStorage.setItem('moduleId', module);
    sessionStorage.setItem('otpVerified', 'true');
    sessionStorage.setItem('otpVerifiedSession', 'true');
    localStorage.removeItem('policyGuestMode');
  }

  const authed = sessionStorage.getItem('otpVerified') === 'true' && !!localStorage.getItem('userToken');
  if (authed) {
    if (sessionStorage.getItem('otpVerifiedSession') !== 'true') {
      sessionStorage.setItem('otpVerifiedSession', 'true');
    }
    return true;
  }

  if (localStorage.getItem('policyGuestMode') === 'true' && state.url.startsWith('/kga-website')) {
    return true;
  }

  return router.createUrlTree(['/sign-in'], { queryParams: route.queryParams });
};
